import React from "react";
import Icon from "../../../UI/Icon";
import banner from "./../../../../assets/flexiassets/flexiassets-banner.jpg";

const FLEXIASSETS_URL = "https://flexiassets.in/";

// Promo for FlexiAssets (a Voorent initiative). The artwork already carries the
// headline and buttons, so the whole banner is one link to the site.
function FlexiAssetsBanner() {
  return (
    <section className="v-flexi" aria-label="FlexiAssets — a Voorent initiative">
      <a className="v-flexi__link" href={FLEXIASSETS_URL}>
        <img
          src={banner}
          alt="FlexiAssets, a Voorent initiative: list and earn from your furniture and appliances. Rent, sell or buy from people near you."
          width="1600"
          height="584"
          loading="lazy"
          decoding="async"
        />
        {/* The artwork's text is too small to read on phones, so a plain CTA follows it there. */}
        <span className="v-flexi__cta">
          <span>
            <strong>List and earn on FlexiAssets</strong>
            <span className="v-flexi__sub">Rent, sell or buy from people near you</span>
          </span>
          <Icon name="arrowRight" size={18} />
        </span>
      </a>
    </section>
  );
}

export default FlexiAssetsBanner;
